{
	"loadingMessage": "Chargement des comptes...",
	"errorMessage": "Erreur lors du chargement des données",
	"emptyMessage": "Aucun compte trouvé",
	"noSearchResults": "Plan comptable introuvable",
	"searchHint": "Rechercher un plan comptable déjà enregistré"
}
